<template>
  <div
    class="relative form-group"
    :class="{error: !slideActive.limitChoice}"
  >
    <label class="label-option">
      {{ labelTitle }}
      <span class="title-table-presentation-tooltip result-layout-tooltip">
        <b-button
          v-tooltip="tooltip"
          class="tooltip-btn"
        />
        <i class="fas fa-question-circle" />
      </span>
    </label>
    <input
      type="number"
      :min="min"
      :max="max"
      class="form-control"
      v-model="slideActive.limitChoice"
      @input="handleInputChange()"
      style="width: 80px;"
    >
    <div class="label-time-to-answer">
      {{ unit }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    labelTitle: {
      type: String,
      default: '',
    },
    unit: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },

  methods: {
    handleInputChange() {
      this.slideActive.limitChoice = parseInt(
        this.slideActive.limitChoice,
        10,
      )
      if (this.slideActive.limitChoice < this.min) {
        this.slideActive.limitChoice = this.min
      } else if (this.slideActive.limitChoice > this.max) {
        this.slideActive.limitChoice = this.max
      }
      this.$emit('updateSetting')
    },
  },
}
</script>

<style lang="scss" scoped>
.label-time-to-answer {
  position: absolute;
  top: 43px;
  left: 90px;
}
</style>
